'use strict';

// Mobile apps controller
angular.module('mobile-apps').controller('TagsController', [
	'$scope',
	'$rootScope',
	'$stateParams',
	'Authentication',
	'TagMain',
	'EntryMain',
	'LanguageEntries',
	'$state',
	'$timeout',
	'SweetAlert',
	'$window',
	function (
		$scope,
		$rootScope,
		$stateParams,
		Authentication,
		TagMain,
		EntryMain,
		LanguageEntries,
		$state,
		$timeout,
		SweetAlert,
		$window
	) {
		$scope.authentication = Authentication;
		$scope.mobileAppId = $stateParams.mobileAppId;
		$scope.TagMain = TagMain;
		$scope.overlayOverwrite = {};

		/**
		 * Adds the entry with the given key to the currently active tag
		 */
		function addEntryToTagCallback(entryKey) {
			if (entryKey) {
				var entry = EntryMain.getEntryByKey(entryKey);

				if (entry) {

					if (entry._tags.indexOf($stateParams.tagId) === -1) {

						$timeout(function() {

							var text = 'The entry "' + entry.key + '" is currently not connected to the current tag. Do you want to connect them?';

							SweetAlert.swal(
								{
									title: 'Are you sure?',
									text: text,
									type: 'warning',
									showCancelButton: true,
									confirmButtonColor: '#DD6B55',
									confirmButtonText: 'Yes, connect!',
									cancelButtonText: 'No, cancel!',
									closeOnConfirm: true,
									closeOnCancel: true
								},
								function (isConfirm) {
									if (isConfirm === true) {

										var tagChanges = {};
										tagChanges[$stateParams.tagId] = 'add';

										LanguageEntries.addRemoveTags({
											mobileAppId: $stateParams.mobileAppId,
											tags: tagChanges,
											entries: [entry.key]
										}, function (response) {
											// Make sure that the data gets reloaded
											$rootScope.$broadcast('entriesChanged');

											$state.go('.', {
												entryId: entry._id
											}, {inherit: true, notify: false});

										}, function (errorResponse) {

											$timeout(function() {
												SweetAlert.swal(
													{
														title: 'Oops!',
														text: 'Sorry something went wrong',
														type: 'error',
														showCancelButton: false
													}
												);
											}, 50);
										});

									}
								}
							);
						}, 50);

						return;
					}

				}
			}
		}

		/**
		 * Sets the object which defines for which overlay additional buttons
		 * should be displayed
		 */
		function setScreenActionButtons() {
			if (TagMain.tag && TagMain.tag._screenshots && TagMain.tag._screenshots.length !== 0) {

				// Reset the buttons
				for (var key in $scope.overlayOverwrite) {
					delete $scope.overlayOverwrite[key];
				}

				var screenshot = TagMain.tag._screenshots[TagMain.screenshotIndex];
				if (screenshot && screenshot.metaData && screenshot.metaData.stringPositions.length) {
					screenshot.metaData.stringPositions.forEach(function(stringPosition) {
						if (stringPosition.x !== -1 && stringPosition.y !== -1) {

							// Check if entry with id exists and if it is
							// already on the currently active tag

                            const stringPositionKey = stringPosition.key || stringPosition.fuzzyKeys[0];
							let entry = EntryMain.getEntryByKey(stringPositionKey, $stateParams.groupId);
							const hiddenEntry = EntryMain.getHiddenEntryDescByKey(stringPositionKey);

							if(!entry && hiddenEntry) {
							    entry = hiddenEntry;
                            }

							if (!entry) {
								// Entry does not exist
								$scope.overlayOverwrite[stringPositionKey] = {
									class: 'field-mouseover other entry-missing',
									buttons: [
										{
											name: 'Entry does not exist'
										}
									]
								};
							}
							else if (angular.isArray(entry._tags) && entry._tags.indexOf($stateParams.tagId) === -1) {
								// Entry exists but is not connected with
								// active tag so add button
								$scope.overlayOverwrite[stringPositionKey] = {
									class: 'field-mouseover other not-on-tag',
									buttons: [
										{
											name: 'Add ID to tag',
											onClick: addEntryToTagCallback
										}
									]
								};
							}

						}
					});
				}
			}
		}


		$scope.initDetailView = function() {
			if (!$stateParams.tagId) {
				return;
			}

			TagMain.loadTag($stateParams.tagId, false,
				function(err, tag) {
					if (err) {
						return;
					}
					TagMain.adjustSidebarWidth();

					var flexibleMatch = true;
					if ($stateParams.hasOwnProperty('mainFilter') && $stateParams.mainFilter) {
						// If there are filter parameters in the url we do
						// a strict match
						flexibleMatch = false;
					}

					var screenshots = TagMain.getScreenshotsFromStateParams(false);
					// If there's no screenshot we minimize tags panel
					if(!screenshots.length){
						$rootScope.$broadcast('minimizeTagsBar', null);
					}
					if ($stateParams.hasOwnProperty('languageId')) {
						if (EntryMain.languages.hasOwnProperty($stateParams.languageId)) {
							var language = EntryMain.languages[$stateParams.languageId].name;
							if (language && screenshots.length === 0 || screenshots[0].metaData.deviceLanguageLong !== language) {
								// If the screenshot that has been found does not
								// have the correct language check if we find a
								// better match
								screenshots = TagMain.getScreenshotsFromStateParams(flexibleMatch);
							}
						}
					}

					TagMain.setScreenshots(screenshots);

					// Make sure to display the buttons correctly as soon as
					// the tag data is available
					setScreenActionButtons();
				}
			);
		};





		$scope.$on('$destroy', function() {
			// Change the size of the sidebar when the Tag-List gets closed
			TagMain.adjustSidebarWidth();
		});


		// Makes sure that when another entry gets selected it updates the
		// active entry on the screenshot
		$scope.$watch('activeEntry.key', function() {
			if ($scope.activeEntry.entry) {
				$scope.setEntryData($scope.activeEntry.entry._id);
			} else {
				// Set to not have any active entry
				$scope.setEntryData();
			}
		});


		/**
		 * Returns if the entry with the given key is on the currently active tag
 	     */
		function isEntryKeyOnActiveTag(key) {
			var entry = EntryMain.getEntryByKey(key);
			if (entry && angular.isArray(entry._tags) && entry._tags.indexOf($stateParams.tagId) !== -1) {
				return true;
			}

			return false;
		}


		// Whenever the entries change we have to update the buttons to not
		// display add-link-buttons for already linked entries
		$scope.$on('viewListUpdated', function () {
			setScreenActionButtons();

			// Check if the currently active entry is part of the active tag
			if (!isEntryKeyOnActiveTag($scope.activeEntry.key)) {
				$scope.setEntryData();
			}

		});


		// Adjust the sidebar width whenever the state or window-resolution changes
		angular.element($window).bind('resize', function() {
			TagMain.adjustSidebarWidth();
		});


		$scope.setEntryData = function(entryId) {
			if (entryId) {
				var entry = EntryMain.getEntryById(entryId);
				if (entry) {
					if (entry.linkedKeys) {
						$scope.activeKeys = [entry.key, ...entry.linkedKeys].join('  -,-  ');
					} else {
						$scope.activeKeys = entry.key;
					}
					return;
				}
			}
			// If no id is given or entry with id does not exist have no key active
			$scope.activeKeys = '';
		};


		/**
		 * Callback which gets called whenever the user clicks on a string
		 * on the screenshot
 	     */
		$scope.keyClickCallback = function(entry) {

			if (entry._tags.indexOf($stateParams.tagId) === -1) {
				// If entry is not in current tag it can not get selected
				return;
			}

			if (!entry.locked) {
				$state.go('.', {
					entryId: entry._id
				}, {inherit: true, notify: false});

				const { key, link, linkedKeys } = entry;

				// Set the new entry
				$rootScope.$broadcast('selectEntryByKey', { key, link, linkedKeys });
			}
		};

	}
]);
